import { Organisation, User, isFeatureEnabledForWorkspace } from "@accurx/auth";
import { Ds } from "@accurx/design";
import { isMyWorkspace } from "@accurx/workspace-management";

export const WorkspaceMenuHeader = ({
    workspace,
    user,
}: {
    workspace?: Organisation;
    user: User;
}) => {
    const isFlexibleWorkspacesEnabled = workspace
        ? isFeatureEnabledForWorkspace("FlexibleWorkspace", workspace)
        : false;

    return (
        <Ds.Flex flexDirection="column" gap="0.25">
            {workspace && (
                <Ds.Flex flexDirection="column" gap="0.25">
                    <Ds.Text weight="bold" size="small" color="zinc">
                        {isMyWorkspace(workspace)
                            ? "My Workspace"
                            : workspace.organisationName}
                    </Ds.Text>
                    {isFlexibleWorkspacesEnabled && (
                        <Ds.Text weight="bold" size="small" color="zinc">
                            {workspace.organisationNodeName}
                        </Ds.Text>
                    )}
                </Ds.Flex>
            )}
            <Ds.Text size="small" color="zinc">
                {user.fullName || user.email}
            </Ds.Text>
        </Ds.Flex>
    );
};
